function guitarGame(obj,conf){
    conf=$.extend({

        button_mobile_path:[],//from conf

        addImages:{
            "stone_left":_IMG_SERV+"/gfx/place/dildogame/ui/stone_left.png",
            "stone_center":_IMG_SERV+"/gfx/place/dildogame/ui/stone_center.png?2",
            "stone_right":_IMG_SERV+"/gfx/place/dildogame/ui/stone_right.png",
            "mobile_down":_IMG_SERV+"/gfx/place/dildogame/ui/mobile/down.png",
            "candle":_IMG_SERV+"/gfx/place/dildogame/ui/candle.png",
            "candle_fire":_IMG_SERV+"/gfx/place/dildogame/ui/candle_fire.png",
            "belt_score":_IMG_SERV+"/gfx/place/dildogame/ui/belt_green.png?2",
            "belt_time":_IMG_SERV+"/gfx/place/dildogame/ui/belt_pink.png?2",
            "animbut1":_IMG_SERV+"/gfx/place/dildogame/guitar/anim_but/1.png",
            "animbut2":_IMG_SERV+"/gfx/place/dildogame/guitar/anim_but/2.png",
            "animbut3":_IMG_SERV+"/gfx/place/dildogame/guitar/anim_but/3.png",
            "butfail":_IMG_SERV+"/gfx/place/dildogame/guitar/red.png",
            "bomb":_IMG_SERV+"/gfx/place/dildogame/guitar/bomb.png",
            "circle0":_IMG_SERV+"/gfx/place/dildogame/guitar/but1.png",
            "circle1":_IMG_SERV+"/gfx/place/dildogame/guitar/but2.png",
            "circle2":_IMG_SERV+"/gfx/place/dildogame/guitar/but3.png",
            "but":_IMG_SERV+"/gfx/place/dildogame/guitar/but/but.png",
            "blank":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/blank.png"
        },
        addImagesMore:{},//from conf
        buttonContainerPos:[0,0],
        buttonPos:[[118,751],[240,751],[360,751]],
        buttonView:[
            [{img:"but",pos:[118,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}],
            [{img:"but",pos:[240,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}],
            [{img:"but",pos:[360,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}]
        ],
        errView:[
            [{img:"butfail",pos:[118,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}],
            [{img:"butfail",pos:[240,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}],
            [{img:"butfail",pos:[360,751],anchor:[0.5,0.5]},{img:"blank",pos:[0,0],anchor:[0.5,0.5]}]
        ],


        itemScale:[50,100],
        buttonPadding:0,
        arrPromo:[100,200,300,400],
        marginTopMobile:-200,
        mobile_extend:0,
        mobile:0,
        bonus2:0,
        score_repeat:0,
        boss_howlong:3000,
        pathConf:[
            {
                url:_IMG_SERV+"/gfx/place/dildogame/guitar/path/left.png",
                anchor:[0,1],
                padding_up:[77,390],//for circle
                padding_down:[-13,-15],//for path
            },{
                url:_IMG_SERV+"/gfx/place/dildogame/guitar/path/center.png",
                anchor:[0.5,1],
                padding_up:[0,390],
                padding_down:[1,-15]
            },{
                url:_IMG_SERV+"/gfx/place/dildogame/guitar/path/right.png",
                anchor:[1,1],
                padding_up:[-72,390],
                padding_down:[14,-15]

            }
        ],
        uiConf:{
            "container_all":{size:[939,73],pos:[482,44]},
            "stone_center":{pos:[177,17]},
            "stone_left":{pos:[0,8]},
            "stone_right":{pos:[745,0]},
            "belt_score":{pos:[183,24]},
            "belt_time":{pos:[183,48]},
            "candle":{pos:[12,1]},
            "fire_pos":[
                [23,1],[49,1],[76,2],[103,3],[130,4]
            ],
            txtScore:{
                pos:[76,43],
                font_color:"#97ef2f",
                border_color:"#0e498f",
                border_size:4,
                font_size:32,
            },
            txtBonus:{
                pos:[158,42],
                font_color:"#ffffff",
                border_color:"#58ba7b",
                border_size:3,
            }
        },
        gameProgress:[],
        gameConf:{},
        hard_id:0,
        howlongEnd:0,
        range:40,
        onLoad:function(){},
        onLoadAfter:function(){},
        onEnd:function(){},
        onItem:function(line_id){},
        onBoss:function(){},
        onSlowTrigger:function(){},
        onScore:function(pos,line_id,img){
            var animObj=new myPixiObj.drawCustom({pos_start:[pos[0],pos[1]],pos_end:[900,500],img:"animbut"+(line_id+1),step_max:100});
            this.animArr.push(animObj);
            this.animContainer.addChild(animObj);
        },
        onWrongControl:function(button_id){

        },
        onPrepareItem:function(line_id){
            return  {
                img:"circle"+line_id,
                anim_type:"img",
            };
        },
        onItemFall:function(line_id,pos,img,item){
            _mySound.playSound("game_lose");
        }

    },conf);

    this.storage={
        was_started:false,
        mobileWasInit:false,
    };
    //marginTopMobile
    var i,bum;
    for(i in conf.addImagesMore){
        conf.addImages[i]=conf.addImagesMore[i];
    }
    delete conf.addImagesMore;
    if(conf.mobile){
        for(i in conf.buttonPos){
            conf.buttonPos[i][1]+=conf.marginTopMobile;
        }
        for(i in conf.pathConf){
            conf.pathConf[i]["padding_up"][1]+=conf.marginTopMobile;
        }
    }
    var html=
        '<canvas id="mainDildoJS" width="1280" height="'+(780+conf.mobile_extend)+'"></canvas>';
    if(obj.find("#mainDildoJS").length==0){
        obj.append(html);
    }
    else{
        obj.find("#mainDildoJS").attr("height",780+conf.mobile_extend);
    }
    html=
        '<div id="touchDivJS"></div>';
    obj.append(html);

    this.touchObj=obj.find("#touchDivJS");
    this.resources={};
    this.canvas=obj.find("#mainDildoJS")[0];
    this.conf=conf;
    this.app = new PIXI.Application({
        width: 1280, height: 780+conf.mobile_extend,antialias: true,transparent:true,
        view:this.canvas
    });

    var app=this.app;
    this.buttonArr=[];
    this.buttonDownArr=[];
    this.buttonMobileArr=[];

    this.delta_slow=0;
    this.slow_conf={howlong:5000,part:50};

    this.buttonContainer=new PIXI.Container();
    this.buttonContainerMobile=new PIXI.Container();
    this.lineContainer=new PIXI.Container();
    this.buttonDownContainer=new PIXI.Container();
    this.animContainer=new PIXI.Container();
    this.externalContainer=new PIXI.Container();
    this.uiContainer=new PIXI.Container();
    this.uiObj={};

    var loaderMain = new PIXI.loaders.Loader();

    this.delta_sum=0;
    this.delta_end=0;

    var i,bum,name;
    for(name in conf.addImages){
        loaderMain.add(name,conf.addImages[name]);
    }
    for(i in conf.pathConf){
        name="pathConf"+i;
        loaderMain.add(name,conf.pathConf[i].url);
        loaderMain.add("butmobile"+i,conf.button_mobile_path[i].url);
    }

    this.objArr=[[],[],[]];
    this.bombArr=[[],[],[]];
    this.animArr=[];
    this.withNameArr={};
    this.state="next";

    this.gameProgress=[];
    if(typeof conf.gameProgress[this.state]!="undefined"){
        this.gameProgress=conf.gameProgress[this.state];
        delete conf.gameProgress[this.state];
    }



    this.step_howlong=1000/60;

    this.was_end=0;
    this.res={
        bonus_step:5,
        is_boss:0,
        fail_id:0,
        score_add:10,
        howlong_path:20,
        next:{
            score:0,
            score_max:0,
            howlong_max:0,
            in_row:0
        },
        boss:{
            score:0,
            score_max:0,
            howlong_max:0,
            in_row:0
        }

    };


    var thc=this;

    loaderMain.load(function(loader, resources){
        var i;
        for(i in resources){
            thc.resources[i]=resources[i];
        }

        thc.init();
    });

    _moduleEvents.one("moduleClear",function(){
        $(document).off("keydown.guitar keyup.guitar");
        if(typeof app!="undefined" && app!=null){
            app.destroy();
        }
        if(typeof loaderMain.reset!="undefined"){
            loaderMain.reset();
        }
    });
}
guitarGame.prototype={
    init:function(){
        this.conf.onLoad.call(this);



        this.buttonContainer.x=this.conf.buttonContainerPos[0];
        this.buttonContainer.y=this.conf.buttonContainerPos[1];



        this.app.stage.addChild(this.buttonDownContainer);
        this.app.stage.addChild(this.lineContainer);
        this.app.stage.addChild(this.animContainer);
        this.app.stage.addChild(this.externalContainer);
        this.app.stage.addChild(this.uiContainer);
        this.app.stage.addChild(this.buttonContainer);

        var i,pos,path_size,line_pos;
        var buttonViewUp,buttonViewDown;
        for(i in this.conf.buttonPos){
            pos=this.conf.buttonPos[i];

            buttonViewUp=this.conf.buttonView[i][0];
            buttonViewDown=this.conf.buttonView[i][1];


            this.buttonArr[i]=new myPixiButton(
                {
                    texture_name:buttonViewUp.img,
                    anchor:buttonViewUp.anchor
                },this.resources
            );

            this.buttonArr[i].x=buttonViewUp.pos[0];
            this.buttonArr[i].y=buttonViewUp.pos[1];

            this.buttonDownArr[i]=new myPixiButton(
                {
                    texture_name:buttonViewDown.img,
                    anchor:buttonViewDown.anchor
                },this.resources
            );
            this.buttonDownArr[i].x=buttonViewDown.pos[0];
            this.buttonDownArr[i].y=buttonViewDown.pos[1];



            var texture =new PIXI.Texture(this.resources["pathConf"+i].texture);
            path_size=[texture.baseTexture.width/2,texture.baseTexture.height];
            var frameRectangle = new PIXI.Rectangle(0, 0, path_size[0],path_size[1]);
            texture.frame= frameRectangle;
            var path=new PIXI.Sprite(texture);
            line_pos=this.takePathPos(i);
            path.x=line_pos[0];
            path.y=line_pos[1];
            path.anchor.set(this.conf.pathConf[i].anchor[0],this.conf.pathConf[i].anchor[1]);
            path.alpha=0;//should be 0

            this.buttonDownContainer.addChild(this.buttonDownArr[i]);
            this.buttonDownContainer.addChild(path);
            this.buttonContainer.addChild(this.buttonArr[i]);
        }
        this.initUI();
        if(this.conf.mobile){
            this.initMobile();
        }
        this.initDesktop();

        this.conf.onLoadAfter.call(this);

        var thc=this;
        this.app.ticker.add(
            function(delta){
                if(thc.storage.was_started){
                    thc.gameLoop(delta);
                }
                else{
                    thc.conf.onUpdate.call(thc,delta);
                }

            }
        );


    },
    initUI:function(){

        var obj;

        var uiConf=this.conf.uiConf;

        this.uiContainer.width=uiConf.container_all.size[0];
        this.uiContainer.height=uiConf.container_all.size[1];

        this.uiContainer.x=uiConf.container_all.pos[0];
        this.uiContainer.y=uiConf.container_all.pos[1];
        if(this.conf.mobile){
            this.uiContainer.y=uiConf.container_all.pos[1]+this.conf.mobile_extend;
        }

        obj=new myPixiElement.img({img:"stone_center"});
        obj.anchor.set(0,0);
        obj.x=uiConf.stone_center.pos[0];
        obj.y=uiConf.stone_center.pos[1];
        this.uiContainer.addChild(obj);


        this.uiObj.beltScore=new myPixiBar({
            texture_name:"belt_score",
            pos:uiConf.belt_score.pos,
            val_max:this.res[this.state].score_max
        },this.resources);
        this.uiObj.beltTimer=new myPixiBar({
            texture_name:"belt_time",
            pos:uiConf.belt_time.pos,
            val_max:this.res[this.state].howlong_max
        },this.resources);
        this.uiContainer.addChild(this.uiObj.beltScore);
        this.uiContainer.addChild(this.uiObj.beltTimer);

        var i,pos_arr=uiConf.fire_pos;
        for(i=0;i<5;i++){
            this.withNameArr["fire"+i]=new myPixiObj.drawCustom({
                img:"candle_fire",
                step_max:0,
                pos_start:[pos_arr[i][0],pos_arr[i][1]-7],
                anim_type:"sprite",
                sprite_conf:{clips:5,frame_start:i}
            });
            this.uiContainer.addChild(this.withNameArr["fire"+i]);
        }

        var candle_was_added=0;
        if(typeof uiConf.candle.zIndex!="undefined" &&  uiConf.candle.zIndex==-1){
            candle_was_added=1;
            obj=new myPixiElement.img({img:"candle"});
            obj.anchor.set(0,0);
            obj.x=uiConf.candle.pos[0];
            obj.y=uiConf.candle.pos[1];
            this.uiContainer.addChild(obj);
        }

        obj=new myPixiElement.img({img:"stone_left"});
        obj.anchor.set(0,0);
        obj.x=uiConf.stone_left.pos[0];
        obj.y=uiConf.stone_left.pos[1];
        this.uiContainer.addChild(obj);

        obj=new myPixiElement.img({img:"stone_right"});
        obj.anchor.set(0,0);
        obj.x=uiConf.stone_right.pos[0];
        obj.y=uiConf.stone_right.pos[1];
        this.uiContainer.addChild(obj);




        if(!candle_was_added){
            obj=new myPixiElement.img({img:"candle"});
            obj.anchor.set(0,0);
            obj.x=uiConf.candle.pos[0];
            obj.y=uiConf.candle.pos[1];
            this.uiContainer.addChild(obj);
        }


        this.uiObj.txtScore=new myPixiObj.showText("0",uiConf.txtScore);
        this.uiObj.txtBonus=new myPixiObj.showText("x1",uiConf.txtBonus);
        this.uiContainer.addChild(this.uiObj.txtScore);
        this.uiContainer.addChild(this.uiObj.txtBonus);
        //belt_timer_path


        this.updateBonus();
        this.updateScore();


    },
    initDesktop:function(){
        var key_line={
            "65":{val:0},
            "83":{val:1},
            "68":{val:2}
        };
        var thc=this;
        $(document).off("keydown.guitar").on("keydown.guitar",function(e){
            if(typeof key_line[e.which]!="undefined"){
                var obj=key_line[e.which],line_id=obj.val;
                e.preventDefault();
                thc.activeButtons([line_id]);
            }
            if(e.which==32){
                e.preventDefault();
                thc.makeGameSlower();
            }
        }).off("keyup.guitar").on("keyup.guitar",function(e){
            if(typeof key_line[e.which]!="undefined"){
                var obj=key_line[e.which],line_id=obj.val;
                e.preventDefault();
                thc.leaveButtons([line_id]);
            }
        });

    },
    initMobile:function(){
        if(this.storage.mobileWasInit){
            return false;
        }
        this.storage.mobileWasInit=true;



        var i,bum,pos;

        var down=new myPixiElement.img({img:"mobile_down"});
        down.y=780+this.conf.mobile_extend;
        down.anchor.set(0,1);

        this.buttonContainerMobile.addChild(down);



        for(i in this.conf.button_mobile_path){
            //butmobile

            pos=this.conf.button_mobile_path[i].pos;
            this.buttonMobileArr[i]=new myPixiButton({texture_name:"butmobile"+i},this.resources);
            this.buttonMobileArr[i].x=pos[0];
            this.buttonMobileArr[i].y=pos[1]+this.conf.mobile_extend;
            this.buttonContainerMobile.addChild(this.buttonMobileArr[i]);
        }

        this.buttonContainer.addChild(this.buttonContainerMobile);
    },
    takeBonus:function(in_row){
        var arrPromo=this.conf.arrPromo;
        var step=Math.floor(in_row/this.res.bonus_step);
        step=Math.min(step,arrPromo.length-1);
        return arrPromo[step];
    },
    countScore:function(howlong,in_row,percent){
        var score=this.res.score_add;
        if(howlong>0){
            if(!percent){
                percent=0;
            }
            score=Math.round(this.res.score_add*Math.min(5,howlong/this.res.howlong_path)*percent/100);
//            if(_ON_DEV){
//                $.qLog(percent+" ");
//            }
        }
        score=Math.round(score*this.takeBonus(in_row)/100);
        return score;
    },
    takePathPos:function(button_id){
        var pos=this.conf.buttonPos[button_id];
        return [
            pos[0]+this.conf.pathConf[button_id].padding_down[0],
            pos[1]+this.conf.pathConf[button_id].padding_down[1]
        ];
    },
    beforeStart:function(){
        if(this.gameProgress.length==0){
            this.res["next"].score=this.conf.score_repeat;
            this.res["next"].score_max=this.res["next"].score;
            this.nextState("boss");
        }
        else{
            this.countMaxScore();
        }
    },
    start:function(){

        this.beforeStart();


        var thc=this;
        var touchObj=new addTouch(this.touchObj[0],{
            onStart:function(arr){
                thc.activeButtons(thc.findButtons(arr));
            },
            onEnd:function(arr){
                var have_ids=thc.findButtons(arr);
                var i,but_key,but,ready=[];
                for(i in thc.buttonArr){
                    but_key=intval(i);
                    if(!in_array(but_key,have_ids)){
                        ready.push(i);
                    }
                }
                thc.leaveButtons(ready);
            },
            onMouseDown:function(arr){
                var have_ids=thc.findButtons(arr);
                if(have_ids.length){
                    thc.conf.onWrongControl.call(thc,have_ids[0]);
                }

            }
        });

        this.storage.was_started=true;

    },
    endGame:function(fail_id){
        if(this.was_end){
            return false;
        }
        this.gameProgress=[];
        this.was_end=1;
        this.res.fail_id=fail_id;
        this.conf.onEnd.call(this);
        return true;
    },
    bombAnim:function(bomb){
        var pos=bomb.takePos();
        bomb.hide();


        var animObj=new myPixiObj.drawCustom({pos_start:pos,pos_end:[900,500],img:"bomb",step_max:100});
        this.animContainer.addChild(animObj);
        this.animArr.push(animObj);
    },
    makeGameSlower:function(){
        if(this.conf.bonus2==0 || this.delta_sum==0){
            return false;
        }
        this.conf.bonus2=0;

        this.delta_slow=this.delta_sum+this.slow_conf.howlong*60/1000/this.slow_conf.part*100;
        this.conf.onSlowTrigger.call(this);
    },
    gameLoop:function(delta){
//        delta=0;
        var delta_sum_old=this.delta_sum;
        if(this.delta_sum<this.delta_slow){
            delta=delta*this.slow_conf.part/100;
        }


        this.delta_sum+=delta;

        var timeArr=[Math.round(delta_sum_old*this.step_howlong),Math.round(this.delta_sum*this.step_howlong)];


        var i,i_max,bum,line_id,obj;
        for(line_id in this.objArr){
            i_max=this.objArr[line_id].length-1;
            for(i=i_max;i>=0;i--){
                obj=this.objArr[line_id][i];
                if(!obj.update(delta)){
                    obj.remove();
                    this.objArr[line_id].splice(i,1);
                }
            }
        }
        for(line_id in this.bombArr){
            i_max=this.bombArr[line_id].length-1;
            for(i=i_max;i>=0;i--){
                obj=this.bombArr[line_id][i];
                if(!obj.update(delta)){
                    obj.remove();
                    this.bombArr[line_id].splice(i,1);
                }
            }
        }

        i_max=this.animArr.length-1;
        for(i=i_max;i>=0;i--){
            obj=this.animArr[i];
            if(!obj.update(delta)){
                obj.remove();
                this.animArr.splice(i,1);
            }
        }
        for(i in this.withNameArr){
            this.withNameArr[i].update(delta);
        }

        var thc=this;

        var arr,obj,tmp,pos_start,pos_end,pos_but,img_name;
        var v_real=this.conf.gameConf[this.state].v,a_real=this.conf.gameConf[this.state].a;
        if(!this.conf.mobile){
            var qPlus=0.3*intval(this.conf.hard_id)/11;;
            qPlus=0;
            v_real+=qPlus;
        }

        while(this.gameProgress.length>0 && this.gameProgress[0].time<=timeArr[1]){
            arr=this.gameProgress.shift();
            //{line_id:2,howlong:100,time:2250,speed:10},

            tmp=this.conf.pathConf[arr.line_id].padding_up;
            pos_start=[this.conf.buttonPos[arr.line_id][0]+tmp[0],0+tmp[1]];
            pos_but=[this.conf.buttonPos[arr.line_id][0],this.conf.buttonPos[arr.line_id][1]];
            tmp=makeVector(pos_start,pos_but);
//
            pos_end=addVector(pos_start,makeVector(pos_start,pos_but,lengthVector(tmp)+this.conf.range));

            obj=false;
            if(arr.type=="norm"){
                img_name="circle"+arr.line_id;
                obj=new guitarGame_item({
                    elementConf:this.conf.onPrepareItem.call(this,arr.line_id),
                    line_id:arr.line_id,
                    pos_start:pos_start,
                    pos_end:pos_end,//pos_end,
                    pos_end_real:pos_but,
                    v:v_real,
                    a:a_real,
                    scale_arr:this.conf.itemScale,
                    howlong:arr.howlong,
                    path_name:"pathConf"+arr.line_id,
                    path_pos:this.takePathPos(arr.line_id),
                    path_anchor:copyArray(this.conf.pathConf[arr.line_id].anchor),
                    onFail:function(line_id,pos,img,item){
                        thc.conf.onItemFall.call(thc,line_id,pos,img,item);
                        thc.failLine(line_id);
                    }
                },this.resources);
                this.objArr[arr.line_id].push(obj);
                this.conf.onItem.call(this,arr.line_id);
            }
            if(arr.type=="bomb"){
                obj=new guitarGame_bomb({
                    anim_type:"img",
                    img:"bomb",
                    line_id:arr.line_id,
                    pos_start:pos_start,
                    pos_end:pos_end,//pos_end,
                    pos_end_real:pos_but,
                    v:v_real,
                    a:a_real,
                    scale_arr:[50,100],
                    bomb_state:this.buttonArr[arr.line_id].takeState(),
                    onFail:function(line_id){
                        thc.endGame(2);
                        thc.bombAnim(this);
                    }
                },this.resources);
                this.bombArr[arr.line_id].push(obj);
            }

            if(obj!==false){
                this.lineContainer.addChildAt(obj,0);
            }


        }
        if(this.gameProgress.length==0){
            var sum=0;
            for(i=0;i<3;i++){
                sum+=this.objArr[i].length;
            }
            if(sum==0){
                this.delta_end+=delta;
                if(this.delta_end*this.step_howlong>this.conf.howlongEnd){

//                    this.app.ticker.stop();
                    if(typeof this.conf.gameProgress["boss"]!="undefined" && this.res['next'].score>=this.res['next'].score_max){
                        this.nextState("boss");

                        this.uiObj.beltTimer.setValMax(this.res[this.state].howlong_max);
                        this.uiObj.beltScore.setValMax(this.res[this.state].score_max);

                        this.updateBonus();
                        this.updateScore();

//                        this.app.ticker.start();

                    }
                    else if(this.was_end==0){
                        this.endGame(0);

                    }
                }
            }
        }
        this.uiObj.beltTimer.updateVal(this.delta_sum*this.step_howlong);

        this.conf.onUpdate.call(this,delta);
    },
    nextState:function(state){
        this.conf.onBoss.call(this);

        var boss_howlong=this.conf.boss_howlong;
        this.delta_sum=0;
        this.delta_end=0;
        this.delta_slow=0;
        this.state=state;
        var i,bum;
        for(i in this.conf.gameProgress[this.state]){
            this.conf.gameProgress[this.state][i].time+=boss_howlong;
        }
        this.gameProgress=this.conf.gameProgress[this.state];
        delete this.conf.gameProgress[this.state];
        this.countMaxScore();


//        var obj=new myPixiObj.showText("Final phase!",{
//            pos:[250,243],
//            font_color:"#97ef2f",
//            border_color:"#0e498f",
//            border_size:4,
//            font_size:33,
//            step_max:100,
//            step_max_fadeout:30,
//        });
//        this.animContainer.addChild(obj);
//        this.animArr.push(obj);

    },
    updateScore:function(){
        this.uiObj.txtScore.changeText(this.res[this.state].score);
        this.uiObj.beltScore.updateVal(this.res[this.state].score);
    },
    updateBonus:function(){

        //this.res[this.state].in_row
        ///this.res.bonus_step
//        var arrPromo={"0":100,"1":200,"2":400};
        var step=Math.floor(this.res[this.state].in_row/this.res.bonus_step);
        var i,show=0;
        if(step>=3){
            show=5;
        }
        else{
            show=this.res[this.state].in_row%this.res.bonus_step;
        }
        var obj;
        for(i=0;i<this.res.bonus_step;i++){
            obj=this.withNameArr["fire"+i];
            if(i>=show){
                obj.alpha=0;
            }
            else{
                obj.alpha=1;
            }
        }

        var bonus_str="x"+Math.floor(this.takeBonus(this.res[this.state].in_row)/100)
        this.uiObj.txtBonus.changeText(bonus_str);
    },
    failLine:function(line_id){
        //butfail




        var conf_up=this.conf.errView[line_id][0];
        var conf_down=this.conf.errView[line_id][1];


        var frontObj=new myPixiObj.drawCustom({
            pos_start:conf_up.pos,pos_end:conf_up.pos,
            anchor:conf_up.anchor,
            img:conf_up.img,step_max:20,
            opacity_arr:[100,20],
        });
        var backObj=new myPixiObj.drawCustom({
            pos_start:conf_down.pos,pos_end:conf_down.pos,
            anchor:conf_down.anchor,
            img:conf_down.img,step_max:20,
            opacity_arr:[100,20],
        });

//        this.buttonDownContainer.addChild(frontObj);//good


        this.buttonDownContainer.addChild(backObj);


        this.buttonContainer.addChild(frontObj);
        this.animArr.push(backObj);
        this.animArr.push(frontObj);

        var in_row_max=this.conf.arrPromo.length*this.res.bonus_step;
        this.res[this.state].in_row=Math.floor(Math.min(this.res[this.state].in_row,in_row_max)/2);
        this.updateBonus();


    },
    leaveButtons:function(ids){
        if(this.was_end){
            return false;
        }
        var i,bum;
        var line_id;
        var k,k_max,obj,pos;
        var res;
        for(i in ids){
            bum=ids[i];
            if(this.buttonArr[bum].setState("normal")){
                this.buttonDownArr[bum].setState("normal");
                line_id=intval(bum);
                k_max=this.objArr[line_id].length-1;
                for(k=k_max;k>=0;k--){
                    obj=this.objArr[line_id][k];
                    res=obj.endCatch();
                    if(res.mili){
                        this.res[this.state].score+=this.countScore(res.mili,this.res[this.state].in_row,res.percent);
                        this.updateScore();
                    }
                }
                k_max=this.bombArr[line_id].length-1;
                for(k=k_max;k>=0;k--){
                    obj=this.bombArr[line_id][k];
                    obj.setState("normal");
                }


                if(this.conf.mobile){
                    this.leaveButtonMobile(line_id);
                }
            }
        }
    },
    leaveButtonMobile:function(line_id){
        this.buttonMobileArr[line_id].setState("normal");
    },
    activeButtons:function(ids){
        if(this.was_end){
            return false;
        }
        var i,bum,k,k_max,obj,pos;
        var line_id;
        var button_pos;
        var was_hit=0;
        var was_try=0;
        var cur_hit,mis_arr=[];

        var rangePow=this.conf.range*this.conf.range;

        for(i in ids){
            bum=ids[i];
            if(this.buttonArr[bum].setState("active")){
                this.buttonDownArr[bum].setState("active");
                was_try++;
                line_id=intval(bum);
                button_pos=this.conf.buttonPos[line_id];
                cur_hit=0;
                k_max=this.objArr[line_id].length-1;
                for(k=k_max;k>=0;k--){
                    obj=this.objArr[line_id][k];
                    pos=obj.takePos();
                    if(lengthVectorPow(minusVector(button_pos,pos))<=rangePow && obj.canCatch()){
                        obj.myObj.alpha=0;
                        var ret=obj.wasCatch();

                        this.conf.onScore.call(this,[ret.x,ret.y],line_id,ret.img);



                        this.res[this.state].score+=this.countScore(0,this.res[this.state].in_row);

                        _mySound.playSound("game_score");

                        this.res[this.state].in_row++;
                        this.updateScore();
                        this.updateBonus();

                        cur_hit=1;
                        was_hit++;
                    }
                }
                k_max=this.bombArr[line_id].length-1;
                for(k=k_max;k>=0;k--){
                    obj=this.bombArr[line_id][k];
                    obj.setState("active");
                }

                if(this.conf.mobile){
                    this.activeButtonMobile(line_id);
                }
                if(cur_hit==0){
                    mis_arr.push(line_id);
                }
            }
        }
        if(was_try>was_hit){
            this.checkWasMissed(mis_arr);
        }

    },
    checkWasMissed:function(mis_arr){
        var button_pos,line_id,obj,k,pos;
        var rangePow=this.conf.range*this.conf.range;
        var was_any=0;
        for(line_id in this.objArr){
            button_pos=this.conf.buttonPos[line_id];
            for(k in this.objArr[line_id]){
                obj=this.objArr[line_id][k];
                pos=obj.takePos();
                if(lengthVectorPow(minusVector(button_pos,pos))<=rangePow && obj.canCatch()){
                    was_any++;
                }
            }
        }
        if(was_any>0){
            for(k in mis_arr){
                line_id=mis_arr[k];
                this.failLine(line_id);
            }



        }


    },
    activeButtonMobile:function(line_id){
        this.buttonMobileArr[line_id].setState("active");
    },
    findButtons:function(arr){
        var ready_arr=[];
        var i,but,k,pos,bum,
            containerOffset=[this.buttonContainer.x,this.buttonContainer.y],
            buttonSize=[],butPos=[],padding=this.conf.buttonPadding;
        for(i in this.buttonMobileArr){
            but=this.buttonMobileArr[i];
            butPos=[but.x,but.y-this.conf.mobile_extend];
            buttonSize=[but.width/2,but.height/2];
            for(k in arr){
                bum=arr[k];
                pos=[bum[0]-containerOffset[0],bum[1]-containerOffset[1]];

                if(
                    pos[0]>=butPos[0]-buttonSize[0]-padding && pos[0]<=butPos[0]+buttonSize[0]+padding &&
                    pos[1]>=butPos[1]-padding-buttonSize[1] && pos[1]<=butPos[1]+buttonSize[1]+padding
                ){
                    ready_arr.push(i);
                }

                //this.conf.buttonPadding
            }
        }
        return ready_arr;
    },
    prepareResAjax:function(){
        if(this.res.boss.score>=this.res.boss.score_max && this.res.boss.score_max){
            this.res.is_boss=1;
        }
        var ret={
            score:this.res["next"].score,
            score_max:this.res["next"].score_max,
            is_boss:this.res.is_boss,
            fail_id:this.res.fail_id
        };

        return ret;
    },
    countMaxScore:function(){
        var arr=[];
        var i,bum;
        var howlong_max=0;
        for(i in this.gameProgress){
            bum=this.gameProgress[i];
            if(bum.type=="norm"){
                if(bum.howlong>0){
                    arr.push({time:bum.time+bum.howlong,howlong:bum.howlong});
                }
                howlong_max=Math.max(howlong_max,bum.time+bum.howlong);
                arr.push({time:bum.time,howlong:0});
            }

        }

        arr.sort(function(a,b){
            if(a.time==b.time){
                return b.howlong-a.howlong;
            }
            return a.time-b.time;
        });


        var score_max=0;
        var in_row=0;
        for(i in arr){
            bum=arr[i];
            score_max+=this.countScore(bum.howlong,in_row,100);
            if(bum.howlong==0){
                in_row++;
            }
        }
        var score_max_org=score_max;
        if(this.state=="next"){
            this.res.next.score=intval(this.conf.score_repeat);
            score_max+=intval(this.conf.score_repeat);
        }

        score_max=Math.round(this.conf.gameConf[this.state].part_need*score_max/100);
        if(this.res[this.state].score>=score_max){
            score_max=intval(this.conf.score_repeat)+Math.ceil(score_max_org/2);
        }



        this.res[this.state].score_max=score_max;
        this.res[this.state].howlong_max=howlong_max;


    }
};